import React from "react";
import "material-symbols/rounded.css";

interface MaterialIconProps {
  icon: string;
  className?: string;
  size?: number;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  grade?: -25 | 0 | 200;
  opticalSize?: 20 | 24 | 40 | 48;
}

const MaterialIcon: React.FC<MaterialIconProps> = ({
  icon,
  className = "",
  size,
  weight = 200,
  grade = 0,
  opticalSize = 48,
}) => {
  return (
    <span
      className={`material-symbols-rounded ${className}`}
      style={{
        fontSize: size ? `${size}px` : undefined,
        width: size ? `${size}px` : undefined,
        height: size ? `${size}px` : undefined,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize}`,
      }}
    >
      {icon}
    </span>
  );
};

export default MaterialIcon;
